import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import { actionTypes, useStateValue } from '../../store';
import Header from '../BaseComponents/Header';
import FotterMain from '../BaseComponents/FotterMain';
import { getCustomerOrderDetails, getpullESBData, orderCencel } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
import { Button, TextField } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';

const validationSchema = yup.object({
    remarks: yup
      .string('')
      .required('Please mention cancellation remarks'),
  });

const OrderDetails = () => {
    const { pageSlug } = useParams();
    const [{ token, huid }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [reqloading, setReqloading] = useState(false);
    const [orderDetails, setOrderDetails] = useState([]);
    //const [orderEDBDetails, setOrderEDBDetails] = useState([]);

    const [openpop, setOpenpop] = useState(false);
    const handleClosepop = () => setOpenpop(false);

    const pullOrderDetails = () => {
        var data = new FormData();
        data.append('customerId', huid);
        // data.append('XAuth', token);
        data.append('orderId', pageSlug);
        for (var pair of data.entries()) {
           // console.log(pair[0] + ', ' + pair[1]);
        }
       setLoading(true)
        getCustomerOrderDetails(data).then((res) => {
          console.log('getCustomerOrderDetails', res.data)
          setLoading(false)
            switch (res.data.status) {
                case 1:
                    setOrderDetails(res.data?.orderData);
                    //setOrderEDBDetails(res.data?.orderData?.orderDetails?.ecomOrderStatus);
                    return true;
                case 0:
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    break;
                case 2:
                    //dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
                    break;
                default:
                    return;
            }
        })
    }
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }


    const formik = useFormik({
        initialValues: {
            remarks: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setReqloading(true)
            var data = new FormData();
            data.append('customerId', huid);
            data.append('orderId', pageSlug);
            // data.append('XAuth', token);
            data.append('remarks', values.remarks);
            orderCencel(data).then((res) => {
              // console.log("response data---- ", res.data);
                setReqloading(false)
                switch (res.data.status) {
                    case 1:
                        setOpenpop(false);
                        pullOrderDetails();
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res?.data?.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res?.data?.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            })
        },
      });


    useEffect(() => {
        if(token != '' && pageSlug !=''){
            pullOrderDetails();
        }
       
    }, [pageSlug]);
    return (
        <>
            <Header />
            {loading ? <><LoadingCellFullPage /></> : <>
                <div className='innerpagebg pt-5 pb-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-9 text-left m-auto'>
                                <div className="d-flex align-items-center">
                                    <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                        <span className='txtred'>Order </span> <span className='txtdgray'>Details ({pageSlug})</span>
                                    </h4>
                                    <div className="ms-auto">
                                        <Button onClick={goBack} className='d-block mt-3 fw-bold'>
                                            BACK
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='container mt-3'>
                        <div className='row'>
                            <div className='col-lg-9 col-md-12 col-12 m-auto'>
                                <div className='card p-3 mb-3'>
                                    <div className="row">
                                        <div className='col-12 col-md-4'>
                                            <h6 className='f14 fw-bold'>Delivery Address</h6>
                                            <div className='fw-bold'>{orderDetails?.orderDeliveryAddressDetails?.addType}</div>
                                            <div>
                                                {orderDetails?.orderDeliveryAddressDetails?.address1}, {orderDetails?.orderDeliveryAddressDetails?.address2}, {orderDetails?.orderDeliveryAddressDetails?.city}, {orderDetails?.orderDeliveryAddressDetails?.state}<br />
                                                {orderDetails?.orderDeliveryAddressDetails?.country}, Pincode: {orderDetails?.orderDeliveryAddressDetails?.ziipcode}
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-4'>
                                            <h6 className='f14 fw-bold'>Billing Address</h6>
                                            <div className='fw-bold'>{orderDetails?.orderBillingAddressDetails?.addType}</div>
                                            <div>
                                                {orderDetails?.orderBillingAddressDetails?.address1},{orderDetails?.orderBillingAddressDetails?.address2}, {orderDetails?.orderBillingAddressDetails?.city}, {orderDetails?.orderBillingAddressDetails?.state}<br />
                                                {orderDetails?.orderBillingAddressDetails?.country}, Pincode: {orderDetails?.orderBillingAddressDetails?.ziipcode}
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-4'>
                                            <div className='f12'>
                                                <span className="text-black fw-bold">Order Date : </span>
                                                <span className="">{orderDetails?.orderDetails?.orderDate}</span>
                                            </div>
                                            <div className='f12 mt-1'>
                                                <span className="text-black fw-bold">Order ID : </span>
                                                <span className="">{orderDetails?.orderDetails?.orderId}</span>
                                            </div>
                                            <div className='f12 mt-1'>
                                                <span className="text-black fw-bold">Order Status : </span>
                                                {/* <span className="">{orderEDBDetails?.items?.[0]?.order_status}</span> */}
                                                 <span className="">{orderDetails?.orderDetails?.orderStatus}</span>
                                            </div>
                                            
                                            {/* <div className='f12 mt-1 d-none'>
                                                <span className="text-black fw-bold">ERP Order Id : </span>
                                                <span className="">{orderEDBDetails?.items?.[0]?.ora_order_number}</span>
                                            </div> */}
                                            {orderDetails && orderDetails?.orderDetails?.canCancel === 1? <>
                                                <div>
                                                <Button color="error" 
                                                    onClick={() => setOpenpop(true)}
                                                     variant='outlined' size='small' type="submit" className='mt-2'>
                                                       Order Cancellation Request
                                                    </Button>
                                                </div>
                                            </>:null}
                                            {orderDetails?.orderDetails?.refundDetails !='' ? <>
                                            <div className='f12 mt-1'>
                                                <span className="text-black fw-bold">Refund Status : </span>
                                                {/* <span className="">{orderEDBDetails?.items?.[0]?.order_status}</span> */}
                                                 <span className="">{orderDetails?.orderDetails?.refundDetails?.acceptRefundStatus}</span>
                                            </div>
                                            </>:<></>}
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className='card p-3 mb-3'>
                                    <h6 className='f14 fw-bold'>Payment Information</h6>
                                    <div className="row">
                                        <div className='col-12 col-md-3 f14'>
                                            <div className='f14 mt-1'>
                                                <span className="text-black fw-bold">Payment Amount </span><br />
                                                <span className="">{orderDetails?.orderDetails?.paymentAmount}</span>
                                            </div>
                                            {orderDetails?.orderDetails?.offer!=null?<>
                                            <div className='mt-2 f12 p-2' style={{backgroundColor:'#fff7e1'}}>
                                                <div className='text-black'>Offers Applied</div>
                                                <div className='text-black'><strong>Coupon Code:</strong> {orderDetails?.orderDetails?.offer}</div>
                                                <div className='text-black'><strong>Total Discount Amount:</strong> {orderDetails?.orderDetails?.offerAmount}</div>
                                            </div>
                                            </>:<></>}
                                        </div>
                                        <div className='col-12 col-md-3 f14'>
                                            <div className='f14 mt-1'>
                                                <span className="text-black fw-bold">Payment Mode </span><br />
                                                <span className="">{orderDetails?.orderDetails?.paymentMode}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-3 f14'>
                                            <div className='f14 mt-1'>
                                                <span className="text-black fw-bold">Transaction ID </span><br />
                                                <span className="">{orderDetails?.orderDetails?.transactionId}</span>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-3 f14'>
                                            <div className='f14 mt-1'>
                                                <span className="text-black fw-bold">Payment Status </span><br />
                                                <span className="">{orderDetails?.orderDetails?.status=='Order Success' ? 'Payment Received' : ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {orderDetails?.orderInvoice!=''?<>
                                    <div className='card p-3 mb-3'>
                                        <h6 className='f14 fw-bold'>Invoice Section</h6>
                                        <div className="row">
                                            {orderDetails && orderDetails?.orderInvoice?.map((invdata, i) => (
                                                <div className='col-12 col-md-3 f14' key={i}>
                                                    <a href={invdata?.File_Path} target='_blank' className='btn btn-sm btn-success'>Download Invoice {i+1}</a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>:<></>}
                                <div className='card p-3 mb-3'>
                                    <h6 className='f14 fw-bold'>Dealer Information</h6>
                                    <div className="row">
                                        <div className='col-12 col-md-4 f14'>
                                            <div className='fw-bold'>{orderDetails?.orderDealerDetails?.dealerName}</div>
                                            <div>
                                                {orderDetails?.orderDealerDetails?.address1}, {orderDetails?.orderDealerDetails?.address2}<br />
                                                {orderDetails?.orderDealerDetails?.city}, {orderDetails?.orderDealerDetails?.state}, {orderDetails?.orderDealerDetails?.country}, Pincode: {orderDetails?.orderDealerDetails?.postalCode}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {orderDetails && orderDetails?.orderProductDetails?.length > 0 && orderDetails?.orderProductDetails?.map((data, key) => (
                                    <div className='card p-3 mb-3' key={key} >
                                        <div className="row text-black">
                                            <div className="col-lg-6 col-12">
                                                <div className="row">
                                                    <div className="col-lg-3 col-12">
                                                        <div className="">
                                                            <div className="" style={{ height: '75px', width: '75px' }}>
                                                                <img className="img-fluid" alt="" src={data?.productImage} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-8 col-12">
                                                        <div className="">
                                                            <div className='fw-bold'></div>
                                                            <div className='f12 mt-1'>
                                                                <span className="fw-bold">{data?.productName}</span>- (<span className="fw-bold">QTY: </span><span className="">{data?.qty}</span>)
                                                            </div>
                                                            <div className='f12 mt-1'>
                                                               
                                                            </div>
                                                            {orderDetails?.orderProductDetails?.offer!=null?<>
                                                            
                                                                <div className='f12 mt-1'>
                                                                    <span className="fw-bold">Discount Amount: </span><span className="">{data?.offerAmount}</span>
                                                                </div>
                                                            </>:<></>}
                                                        </div>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-12">
                                                {/* <CurrencyRupeeIcon className='f14 fw-bold' />{data?.price} */}
                                            </div>
                                            {/* <div className="col-lg-4 col-12">
                                                    <div>
                                                        <span className="f12 fw-bold"><Brightness1Icon className='text-success f12 me-1' />Refund Completed</span>
                                                        <div className="f12 text-muted">You returned this order because you needed it in a smaller size. </div>
                                                    </div>
                                                </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <Modal
                        size="md"
                        show={openpop}
                        backdrop="static"
                        keyboard={false}
                        centered
                        contentClassName='border-0 rounded-0'
                        onHide={() => handleClosepop()}
                        aria-labelledby=""
                    >
                        <Modal.Body className="p-0">
                        <div onClick={() => handleClosepop()} aria-label="delete" size="small" className="position-absolute top-0 end-0 btn-out">
                            <CloseIcon fontSize="small" className='text-white' />
                        </div>
                        <div className='p-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>Request</span> <span className='txtdgray'>order cancellation</span>
                                    </h4>
                                </div>
                            </div>
                            <form onSubmit={formik.handleSubmit} autoComplete="off">
                                <div className='row mt-3'>
                                     <div className='col-12'>
                                       <p>Why you would like to cancel this order</p>
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="remarks"
                                            name="remarks"
                                            label="Cancellation Reason"
                                            value={formik.values.remarks}
                                            onChange={formik.handleChange}
                                            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                                            helperText={formik.touched.remarks && formik.errors.remarks}
                                        />
                                    </div>
                                    <div className='col-12 text-end'>
                                        
                                        {!reqloading ? <Button color="error" variant="contained" className='' type="submit">
                                            SUBMIT
                                        </Button> : <LoadingButton
                                                        loading
                                                        loadingPosition="end"
                                                        variant="contained"
                                                    >
                                                    WAIT...
                                        </LoadingButton>}
                                    </div>
                                </div>
                            </form>
                        </div>

                        </Modal.Body>
                    </Modal>

                </div>

            </>}

            <FotterMain />
        </>
    )
}

export default OrderDetails